export default __webpack_public_path__ + "static/media/updated2_rom.cfb36881.svg";